<template>
  <div class="container-search">
    <div class="title">Container Search</div>
    <common-card class="container-query-container" :has-header="false">
      <div class="container-query-container__inner">
        <el-input
          class="container-ids-input"
          type="textarea"
          placeholder="Input the Container IDs here, add space between IDs"
          v-model="containerIDs"
        >
        </el-input>
        <el-button
          type="success"
          class="feature-secondary"
          @click="searchContainers"
        >
          Search
        </el-button>
      </div>
    </common-card>
    <div class="tab-container">
      <el-tabs v-model="curTab">
        <el-tab-pane
          v-for="dock in Object.keys(ContainerDocks)"
          :key="'container-tab-' + dock"
          :label="dock"
          :name="dock"
        />
        <basic-table
          class="container-table"
          :table-headers="ContainerDocks[curTab]"
          :action-min-width="160"
        >
        </basic-table>
      </el-tabs>
    </div>
  </div>
</template>
<script>
// models
import { ContainerDocks } from '@/core/models/container'
// components
import BasicTable from '@/components/common/BasicTable.vue'
import CommonCard from '@/components/common/CommonCard.vue'

export default {
  name: 'ContainerSearch',
  components: {
    BasicTable,
    CommonCard
  },
  data() {
    return {
      ContainerDocks,
      curTab: Object.keys(ContainerDocks)[0],
      containerIDs: ''
    }
  },
  methods: {
    searchContainers() {}
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.container-search {
  height: 100%;

  .title {
    font-size: 24px;
    margin-left: 20px;

    @extend .bold-oswald;
  }

  .container-query-container {
    @extend .global-margin;

    .container-query-container__inner {
      @extend .f-r;

      gap: 20px;
      align-items: center;

      .container-ids-input {
        width: 500px;
      }
    }
  }

  .tab-container {
    @extend .global-margin;
    @extend .shadow-level-three;

    border-radius: $home-card-border-radius;
    padding: $home-card-padding-y $home-card-padding-x;
    background-color: white;

    .container-table {
      margin-top: 15px;
    }
  }
}
</style>
